<div id="main">
  <header class="position-fixed">
    <div class="logo d-flex align-items-center">
      <img src="./assets/images/logo-antenas.png" alt="TVA Antenas" />      
    </div>
    <div class="nav d-flex">
      <div class="nav__titulo">
      </div>
      <div class="nav__menu ml-auto">
        <div class="nav__menu--item">
        </div>
      </div>
    </div>
  </header>
  <div class="wrapper">
    <div class="sidenav sticky-top">      
      <div class="sidenav__logo">
        <img class="logo-gs" src="assets/images/logo-GS.svg" width="150" height="150" alt="logo-gs" />
        <span class="caption text-center">Todos los derechos reservados</span>
        <span class="caption text-center">Aviso de privacidad</span>
      </div>
    </div>
    <section class="home" style="overflow: auto">
      <div class="container-fluid planeacion">        
        <div class="container-fluid bg-box container-custom">
            <markdown src="assets/aviso_privacidad/Sitios_Telecom_GS_Aviso_Privacidad_2025.md"></markdown>
        </div>
      </div>
    </section>
  </div>
</div>

<div id="div-loader" class="div-loader" style="display: none">
  <div class="loader-cal" id="loader">
    <div class="item item-1"></div>
    <div class="item item-2"></div>
    <div class="item item-3"></div>
    <div class="item item-4"></div>
  </div>
</div>
